import { useContext, useMemo } from 'react';
import DatagridContext from './DatagridContext';
import merge from 'lodash/merge';

export const useDatagridContext = (
    props
) => {
    const context = useContext(DatagridContext);

    return useMemo(
        () =>
            merge(
                {},
                context,
                props != null ? { isRowExpandable: props.isRowExpandable } : {}
            ),
        [context, props]
    );
};
